module.exports = __webpack_public_path__ + "img/news.dacc62ae.png";